export default "__VITE_ASSET__GogleyVo__"